module.exports = __webpack_public_path__ + "static/media/icon_person.115452bc.png";